import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectValidRefreshToken } from '../api/services/user/userSlice';


export default function PrivateRoute({ children }) {
  const refresh_token = useSelector(selectValidRefreshToken);
  return refresh_token ? children : <Navigate to="/login" />;
}